import { BannerAPIContentType } from 'src/services/responseTypes/BannerApiResponse';
import { Assets, CoverSection, Image } from 'src/types/subscription';
import { TAG_NAME } from 'src/utils/constants/TagNameConstants';
import { SubscriptionFallbackEnums } from 'src/utils/constants/utilConstants';
import { getImageURL } from 'src/utils/ImageHelper/ImageURLGenerator';

import { ImageContainer, topContainer } from './style';
import { useAppStore } from '../../../hooks/useAppStore';

const FALLBACK_IMAGE = SubscriptionFallbackEnums.CONTEXT_BANNER;

/*
 * Selects the eligible candidate based on the priority list
 * */
const selectCandidate = (data: CoverSection) => {
  const { priorities, assets } = data;
  const selectedIndex = priorities.findIndex((item: string) => {
    if (assets[item as keyof Assets] && assets[item as keyof Assets]?.length)
      return item;
  });
  if (selectedIndex < 0) {
    return null;
  }
  const type = priorities[selectedIndex];
  return { type, data: assets[type as keyof Assets] };
};

const getCoverImage = (data?: Image[], deviceWidth = 360) => {
  if (!data) return FALLBACK_IMAGE;
  const imageURL = getImageURL({
    deviceWidth,
    tagName:
      deviceWidth < 1200
        ? TAG_NAME.SUBS_BANNER_LANDSCAPE
        : TAG_NAME.SUBS_BANNER_PORTRAIT,
    item: { image: data?.[0] } as BannerAPIContentType
  });
  return imageURL;
};

const FallbackImage = () => {
  return (
    <div css={topContainer}>
      <ImageContainer src={FALLBACK_IMAGE} />
    </div>
  );
};

const ContextualBanner = ({ data }: { data?: CoverSection }) => {
  //Assert data is from highest to lowest priority
  const { appConfig: { deviceWidth = 768 } = {} } = useAppStore();

  const selectedAsset = data ? selectCandidate(data) : null;
  // If nothing is found select default image
  if (!selectedAsset) {
    return <FallbackImage />;
  }
  // Select based on priority
  const { type, data: assetData } = selectedAsset;
  if (type === 'images') {
    const imageUrl = getCoverImage(assetData as Image[], deviceWidth);
    return (
      <div css={topContainer}>
        <ImageContainer fetchPriority="high" src={imageUrl} />
      </div>
    );
  }
  return <FallbackImage />;
};
export default ContextualBanner;
